import { Component, ViewChild, ElementRef } from '@angular/core';
import { ConnectInterfacesService } from '../core/connect-interfaces.service';
import { BzgToastService, BzgModalService, BzgToastType } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from 'i18n/i18n.service';
import { PendingChangesAuthenticationAlertComponent } from 'app/security/security-authentication/modal-actions/security-authentication-pendingchanges.component';
import { CryptoDataService } from 'app/core/services/crypto.data.service';
import { PendingChangesConnectAlertComponent } from '../modal-actions/connect-pendingchanges.component';
import { ConnectInterfacesPropertiesComponent } from './connect-interfaces-properties/connect-interfaces-properties.component';
import { ConnectInterfacesAdvComponent } from './connect-interfaces-adv/connect-interfaces-adv.component';
import { IConnectInterface } from '../core/IConnectInterface';
import { IConnectInterfacesMetadata } from '../core/IConnectInterfacesMetadata';
import { IExternalSystem } from '../core/IExternalSystem';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
    selector: 'connect-interfaces',
    templateUrl: 'connect-interfaces.component.html',
    styleUrls: ['connect-interfaces.component.scss']
})
export class ConnectInterfacesComponent {
    @ViewChild('propertiesForm', { static: false}) interfacesPropertiesComponent: ConnectInterfacesPropertiesComponent;
    @ViewChild('propertiesForm', { static: false}) interfacesAdvComponent: ConnectInterfacesAdvComponent;

    public externalSystems: IExternalSystem[];
    public connectIntefaces: IConnectInterface[];
    public contentTypes: string[];
    public selectedExternalSystem: IExternalSystem;
    public selectedInterface: IConnectInterface;
    public prevSelectedInterface: IConnectInterface;
    public isBusy: boolean;
    public interfacesMetadata: IConnectInterfacesMetadata;
    public selectedTab: number = 0;

    constructor(private _connectInterfacesService: ConnectInterfacesService, private _toastService: BzgToastService,
        private _translateService: TranslateService, private _modalService: BzgModalService,
        private _cryptoDataService: CryptoDataService, private _i18nService: I18nService,
        private _showToastService: ShowToastService) { }

    async ngOnInit() {
        this.interfacesMetadata =  await this._connectInterfacesService.getMetadata();
        this._connectInterfacesService.getExternalSystems().subscribe((data) => {
            this.externalSystems = data;
        });
        this._connectInterfacesService.getContentTypes().subscribe((data) => {
            this.contentTypes = data;
        });
    }

    selectExternalSystem(externalSystem: IExternalSystem) {
        this.selectedExternalSystem = externalSystem;
        this.selectedInterface = null;
    }

    async applyChanges() {
        if(this.interfacesPropertiesComponent.isValid()){
            this.isBusy = true;
            this.prevSelectedInterface = _.cloneDeep(this.selectedInterface);
            await this.encryptPasswords();
            await this._connectInterfacesService.updateInterface(this.selectedInterface).toPromise();
            this._showToastService.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success');
            this.isBusy = false;
        }
        else {
            this._showToastService.showToast(this._i18nService.instant('GLOBAL.INVALID_FORM'), 'error');
        }
    }

    public cancelChanges(){
        this.selectedInterface = this.prevSelectedInterface;
    }

    private _showPendingChangesDialog(saveAction: Function, cancelAction: Function) {
        const modal = this._modalService.open(PendingChangesConnectAlertComponent,
          {closeOnBackdropClick: false, closeOnRouterNavigation: true});
        modal.afterClosed().subscribe((result: string) => {
            if (result === 'save') {
                saveAction();
            } else {
                cancelAction();
            }
        });
    };

    async selectInterface(_interface: IConnectInterface) {
        this.isBusy = true;
        if (this.prevSelectedInterface && this.selectedInterface) {
            if (!_.isEqual(this.prevSelectedInterface, this.selectedInterface)) {
                this._showPendingChangesDialog(async () => {
                    await this.applyChanges();
                    this.setSelectedInterfacePrev(_interface);
                }, () => {
                    this.setSelectedInterfacePrev(_interface)
                });
            } else {
                this.setSelectedInterfacePrev(_interface);
            }
        } else {
            this.setSelectedInterfacePrev(_interface);
        }

        this.isBusy = false;
    }

    private async setSelectedInterfacePrev(_interface) {
        this.selectedInterface = await this._connectInterfacesService.getInterface(_interface.id).toPromise();
        this.selectedInterface.interface.id = _interface.id;
        this.selectedInterface.environment.url = this.selectedInterface.environment.security['url'] ? this.selectedInterface.environment.security['url'] : this.selectedInterface.environment.url;
        delete this.selectedInterface.environment.security['url'];
        this.prevSelectedInterface = _.cloneDeep(this.selectedInterface);
    }

    private async encryptPasswords() {
        this.selectedInterface.environment.security.password = this.selectedInterface.environment.security.password ?
          (await this._cryptoDataService.encryptString(this.selectedInterface.environment.security.password)
          .toPromise()).encryptedPassword : '';
        if (this.selectedInterface.environment.messagesecurity) {
            this.selectedInterface.environment.messagesecurity.forEach(async secOption => {
                secOption.password = (await this._cryptoDataService.encryptString(secOption.password).toPromise()).encryptedPassword;
            });
        }
    }

}
